import React from 'react'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import config from 'config'

// import Accordion from 'srcReact/components/common2/Accordion'
import Accordion from 'srcReact/components/common/AccordionComponent'
// import { Interest } from '../steps/Interest'

import styles from './styles.module.scss'

const SignupStep = ({
  accordionInvisible,
  accordionDatas,
  isMobile,
  t,
  title,
  currentStep,
  rightTitle,
  leftImage,
  description,
  Component,
  setSuccess,
  updateStep,
  previousStep,
  setPreviousStep,
  goToPreviousStep,
  formState,
  setFormState,
  setNewAccountDatas
}) => {
  return (
    <div className={styles.login}>
      <div className={styles.loginContainer}>
        {!isMobile && (
          <div className={`${styles.loginLeft}`}>
            <div className={styles.headerLeft}>{rightTitle}</div>
            <div className={styles.descriptionLeft}>{description}</div>
            {leftImage && <img className={styles.leftImage} src={config.assetUrl + leftImage} alt='' />}
          </div>
        )}
        <div className={`${styles.loginRight} ${currentStep === 'interest' && styles.loginRightInterest}`}>
          <h1 className={styles.titleRight}>{title}</h1>
          {isMobile && <div className={styles.descriptionRight}>{description}</div>}
          <Component
            title={title}
            setSuccess={setSuccess}
            updateStep={updateStep}
            previousStep={previousStep}
            setPreviousStep={setPreviousStep}
            goToPreviousStep={goToPreviousStep}
            formState={formState}
            setFormState={setFormState}
            setNewAccountDatas={setNewAccountDatas}
          />
          {/* <Interest
            title={title}
            setSuccess={setSuccess}
            updateStep={updateStep}
            previousStep={previousStep}
            setPreviousStep={setPreviousStep}
            goToPreviousStep={goToPreviousStep}
            formState={formState}
            setFormState={setFormState}
          /> */}
        </div>
      </div>
      {accordionDatas && (
        <Accordion data={accordionDatas} customAccdnClass={styles.accordion} accordionInvisible={accordionInvisible} />
      )}
    </div>
  )
}

function mapStateToProps(state) {
  const { common } = state
  const { isMobile } = common
  return {
    isMobile
  }
}

const actionCreators = {}

const ExtendedComponent = withTranslation('common')(SignupStep)

const connectedSignupStep = connect(mapStateToProps, actionCreators)(ExtendedComponent)
export { connectedSignupStep as SignupStep }
